import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportBoundaryTerritoryAssignmentsContainer,
  type ExportBoundaryTerritoryAssignmentsContainerProps,
} from './exportBoundaryTerritoryAssignments.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportBoundaryTerritoryAssignments: ExportBoundaryTerritoryAssignmentsContainerProps;
  }
}
modalRenderer.register('ExportBoundaryTerritoryAssignments', ExportBoundaryTerritoryAssignmentsContainer);
